module.exports = __webpack_public_path__ + "static/media/nosotros-icon.5b0fa86e.svg";